/* @ngInject */
function UpdatePasswordController ($scope, $location, $timeout, $stateParams, $translate, $rootScope, $state, AuthService, StrongPasswordService, InitializerService, SegmentService, BackendErrorParserService) {
  const host = $location.host()
  $scope.subdomain = ''
  $scope.backgroundUrl = ''
  $scope.customerLogoPath = ''

  $scope.flags = {
    loadingBackground: true,
    loadingLogo: true,
    loadingButton: false,
    invalidToken: false,
    passwordAlreadyUsed: false
  }

  $scope.form = {
    oldPassword: '',
    password: '',
    confirmPassword: ''
  }

  $scope.userName = ''

  $scope.showOldPassword = true

  $scope.passwordRules = {
    eight: false,
    uppercase: false,
    lowercase: false,
    number: false,
    special: false
  }

  $scope.passwordStrength = 'NONE' // NONE, ONE, TWO, THREE, FOUR, FIVE
  $scope.strongPasswordEnabled = false

  $scope.wrongMessage = {}

  const api = {
    _arePasswordsEqual,
    _successUpdatePassword,
    _errorUpdatePassword
  }

  this.getApi = () => api

  activate()

  function activate () {
    AuthService.setContainerPosition()
    AuthService.getCustomerImages(host).then(url => {
      $scope.subdomain = localStorage.getItem('companySubdomain')
      $scope.customerLogoPath = url.logo
      $scope.backgroundUrl = url.background
    }).finally(() => {
      $scope.flags.loadingBackground = false
    })

    if ($stateParams.oldPassword) {
      $scope.form.oldPassword = $stateParams.oldPassword
      $scope.showOldPassword = false
    }

    const urlParams = $location.search()

    if ($stateParams.username) {
      $scope.userName = $stateParams.username
    } else if (urlParams.username) {
      $scope.userName = urlParams.username
    }

    const texts = {
      strength: $translate.instant('updatePasswordDescription'),
      expiration: $translate.instant('expiredPasswordDescription')
    }

    const type = $stateParams.type || $location.search().type

    $scope.descriptionText = texts[type]

    StrongPasswordService.checkIfNeedsStrongPassword($stateParams.token).then(info => {
      $scope.strongPasswordEnabled = info.hasStrongPasswordActive
    })
  }

  $scope.onLogoLoad = function () {
    $timeout(() => {
      $scope.flags.loadingLogo = false
    })
  }

  $scope.onOldPasswordChange = function (evt) {
    $scope.form.oldPassword = evt.detail.value
  }

  $scope.onPasswordChange = function (evt) {
    $scope.form.password = evt.detail.value
    if ($scope.strongPasswordEnabled) {
      $scope.passwordStrength = StrongPasswordService.verifyPasswordStrength($scope.form.password, $scope.passwordRules)
    }
  }

  $scope.onConfirmPasswordChange = function (evt) {
    $scope.form.confirmPassword = evt.detail.value
  }

  $scope.showPasswordTooltip = function () {
    if ($scope.strongPasswordEnabled) {
      $('.update-password-container .strong-password-tooltip').removeClass('hidden-tooltip')
    }
  }

  $scope.hidePasswordTooltip = function () {
    if ($scope.strongPasswordEnabled) {
      $('.update-password-container .strong-password-tooltip').addClass('hidden-tooltip')
    }
  }

  $scope.isButtonDisabled = function () {
    const inputsEmpty = !$scope.form.password || !$scope.form.oldPassword || !$scope.form.confirmPassword
    let passwordRulesNotChecked = false
    if ($scope.strongPasswordEnabled) {
      passwordRulesNotChecked = $scope.passwordStrength !== 'FIVE'
    }

    return inputsEmpty || passwordRulesNotChecked
  }

  $scope.changePasswordClick = function () {
    $scope.wrongMessage = {}

    if (!api._arePasswordsEqual()) return

    $scope.flags.loadingButton = true
    $scope.flags.passwordAlreadyUsed = false

    const payload = {
      oldPassword: $scope.form.oldPassword,
      newPassword: $scope.form.password
    }

    StrongPasswordService.updatePassword($stateParams.token, payload).then(api._successUpdatePassword).catch(api._errorUpdatePassword)
  }

  function _arePasswordsEqual () {
    if ($scope.form.password !== $scope.form.confirmPassword) {
      $scope.wrongMessage.newPassword = $translate.instant('passwordNotEqualMsg')
      return false
    }

    return true
  }

  function _successUpdatePassword (info) {
    AuthService.setJwtToken(info.token)
    return InitializerService.initApplication().then(() => {
      $scope.flags.loadingButton = false
      $state.go('home')

      $timeout(() => {
        SegmentService.track('user-login', { id: $rootScope.oUser.id, sso_enabled: false })
      }, 100, false)
    })
  }

  function _errorUpdatePassword (error) {
    $scope.flags.loadingButton = false

    if (BackendErrorParserService.passwordAlreadyUsed(error)) {
      $scope.flags.passwordAlreadyUsed = true
    } else if (error.status === 403) {
      $scope.wrongMessage.oldPassword = $translate.instant('wrongPasswordError')
    } else if (error.status === 404) {
      $scope.flags.invalidToken = true
    }
  }
}

export { UpdatePasswordController }
